// Module
var code = " <p class=\"item-amount\"> <span ng-bind=\"$ctrl.donationItem.total_collected | currency : $ctrl.gbApp.getCurrencySymbol() : 0\"></span> </p> ";
// Exports
export default code;